import { getNanoId, slugOf } from '../../functions'

export const getCsvFileName = (file: File) => {
  const nanoId = getNanoId(6)
  const fileNameWithoutExtension = file.name.replace(/\.[^/.]+$/, '')
  const slugFileName = slugOf(fileNameWithoutExtension)
  return `${nanoId}::${slugFileName}`
}
